import { get, } from '.';

export function GetWebhookEvents(options = {}) {
	return get<any>("/app/api/webhook_events", options);
}
